const NavbarV2 = () => null;
export default NavbarV2;